// Empresa atual (da URL /app/:companyId/...). Disponível para todas as telas da empresa.
import { createContext, useContext, type ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { CompanyDto, Permission } from '@impulso/shared'
import { api } from './api'

const CompanyContext = createContext<CompanyDto | null>(null)

export function useCompanyQuery(companyId: string | undefined) {
  return useQuery({
    queryKey: ['company', companyId],
    queryFn: () => api.get<CompanyDto>(`/companies/${companyId}`),
    enabled: !!companyId,
  })
}

export function CompanyProvider({ company, children }: { company: CompanyDto; children: ReactNode }) {
  return <CompanyContext.Provider value={company}>{children}</CompanyContext.Provider>
}

/** Empresa atual. Só use dentro de /app/:companyId/... */
export function useCompany(): CompanyDto {
  const c = useContext(CompanyContext)
  if (!c) throw new Error('useCompany fora de uma rota de empresa')
  return c
}

export function useCan(permission: Permission): boolean {
  const c = useContext(CompanyContext)
  return !!c?.access.permissions.includes(permission)
}
